module.exports = __webpack_public_path__ + "static/media/Communication_with_community_resources.0dce8882.png";